import React from 'react';

import { FlowContextProvider, StepWrapper, useMutation } from '@betterment/js-runtime';
import { Helmet } from 'react-helmet';
import { Route, Routes } from 'react-router-dom';

import Perform from './Perform';
import Success from './Success';

import { useCustomer } from '../Checking/components/CustomerProvider';
import SudoRouteComponent from '../Checking/components/SudoRouteComponent';
import { PinResetParams } from '../Checking/data';
import { urlBuilder } from '../Shared/urlBuilder';

const PinChangeController: React.FC = () => {
  const { customer } = useCustomer();
  const cardId = customer.card.id;
  const [postPinReset] = useMutation<{}, PinResetParams>(urlBuilder.postPinReset(cardId));

  return (
    <SudoRouteComponent>
      <Helmet>
        <title>Change PIN</title>
      </Helmet>
      <FlowContextProvider
        returnToPath={urlBuilder.getAppChecking.absolute()}
        basePath="/checking/pin_change"
        routePath=""
      >
        <Routes>
          <Route
            data-feature="checking_card_management"
            path="/perform"
            element={
              <StepWrapper name="perform">
                {stepProps => <Perform {...stepProps} onPinReset={postPinReset} />}
              </StepWrapper>
            }
          />
          <Route
            data-feature="checking_card_management"
            path="/success"
            element={<StepWrapper name="success">{stepProps => <Success {...stepProps} />}</StepWrapper>}
          />
        </Routes>
      </FlowContextProvider>
    </SudoRouteComponent>
  );
};

export default PinChangeController;
